module.exports = __webpack_public_path__ + "files/22ce3dbfdc4e175ff60d5cb3cf6528cc.png";


//////////////////
// WEBPACK FOOTER
// ./images/filesOverlay.png
// module id = 1765
// module chunks = 59